import Lenis from 'lenis'
import gsap from '../gsap/gsap.min.js'

// top of _lenis.js
import { ScrollTrigger } from '../gsap/ScrollTrigger.min.js'
window.__ST_lenis = ScrollTrigger;

// Initialize Lenis
const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
  direction: "vertical",
  gestureDirection: "vertical",
  smooth: true,
  smoothTouch: false,
  touchMultiplier: 2,

  // Prevent scroll inside offcanvas
  prevent: (node) => {
    return node.closest('.offcanvas')
  }
})

// ── Wire Lenis ↔ ScrollTrigger together ──
// 1. Update ScrollTrigger every time Lenis scrolls
lenis.on('scroll', ScrollTrigger.update)

// 2. Drive Lenis from GSAP's ticker (replaces the manual RAF loop below)
gsap.ticker.add((time) => {
  lenis.raf(time * 1000)   // GSAP ticker is in seconds, Lenis wants ms
})
gsap.ticker.lagSmoothing(0)

// ── Hash scrolling (owns what anchors:true used to do) ──
// One helper, fired by the two events that bring a hash into being:
//   load       → arriving from another page (full reload)
//   hashchange → clicking a hash link while already on this page
function scrollToHash() {
  const target = location.hash && document.querySelector(location.hash)
  if (target) lenis.scrollTo(target)
}

window.addEventListener('load', scrollToHash)
window.addEventListener('hashchange', scrollToHash)

// expose for anchor scrolling below
export { lenis }
